<nav>
  <!-- Main Top area that contains logo, controls, and user info -->
  <div class="main">
    <a href="/dashboard">
      <img
        src="https://nichepharma-assets.fra1.cdn.digitaloceanspaces.com/tacitapp_logo_default.png"
        alt="Tacitapp"
        class="logo"
      />
    </a>

    <div class="controls">
      <!-- TODO: Language Selection -->
      <!-- <app-select
        size="sm"
        [options]="languageOptions"
        [disableSearch]="true"
        [defaultOption]="language"
        (getSelectedOption)="changeLanguage($event)"
      >
      </app-select> -->

      <!-- TODO: Calendar Pop up -->

      @if (dictionaryService.language === 'en') {
        <button
          [buttonTheme]="
            'primary' 
          "
          buttonType="square"
          (click)="setLanguage('ar')"
        >
          العربية
        </button>
      }

      @if (dictionaryService.language === 'ar') {
        <button
          [buttonTheme]="
            'primary'
          "
          buttonType="square"
          (click)="setLanguage('en')"
        >
          English
        </button>
      }

      <button
        buttonTheme="light"
        buttonType="square"
        class="calendar"
        (click)="openTimeRangeModal()"
        title="Select time range"
        aria-label="Select time range"
      >
        <ng-icon name="iconoirCalendar" size="20"></ng-icon>
      </button>

      <button
        buttonTheme="light"
        buttonType="square"
        (click)="authService.logout()"
        class="logout"
        title="Logout"
        aria-label="Logout"
      >
        <ng-icon name="iconoirLogOut" size="20"></ng-icon>
      </button>
      <div class="user-handle">
        <div class="user-icon">
          {{ userInitial() }}
        </div>
        <small class="username">{{ userName() }}</small>
      </div>
    </div>
  </div>

  <!-- Bottom area that contains dashboard routes -->
  <div data-simplebar data-simplebar-auto-hide="false" class="routes">
    <!-- TODO: implement filtering for menuItems -->
    @for (route of routes(); track route.path; let last = $last) {
      <ng-container>
        <a
          routerLink="{{ route.path }}"
          class="route"
          routerLinkActive="active"
        >
          <ng-icon name="{{ route.icon }}" size="28" strokeWidth="2"></ng-icon>
          <span>{{ route.name }}</span>
        </a>
        @if (!last) {
          <div
            [ngClass]="{
              spacer: true,
              static: routes().length <= 5,
            }"
            class="spacer"
          ></div>
        }
      </ng-container>
    }
  </div>
</nav>

<!-- Time Range Modal -->
<app-time-range-modal
  [isOpen]="isTimeRangeModalOpen()"
  (onClose)="closeTimeRangeModal()"
></app-time-range-modal>
